import { Tabs } from '@mui/base'
import { styled } from '@mui/material'
import useGetTabsTemplate from '~/src/components/mui-wrappers/styled/ordering-methods/tabs/styles/useGetTabsTemplate'

const OrderingMethodsTabs = styled(Tabs)(() => useGetTabsTemplate().getComponentSx())

export default OrderingMethodsTabs
